module.exports = __webpack_public_path__ + "img/risklevelR4.88456d97.png";